module.exports = __webpack_public_path__ + "img/weight3.7f19994d.svg";